import { COMMON_CONTENT } from './common';

export const PRODUCT_DETAILS_CONTENT = {
  notFound: {
    title: 'Product Not Found',
    description: "The cuddly friend you're looking for doesn't exist.",
    icon: 'AlertCircle',
  },
  badges: {
    new: 'New',
    sale: 'Sale',
    outOfStock: 'Out of Stock',
  },
  actions: {
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    addToWishlist: 'Add to Wishlist',
    removeFromWishlist: 'Remove from Wishlist',
    share: 'Share',
    backToShop: 'Back to Shop',
  },
  quantity: {
    label: 'Quantity:',
    decreaseAria: 'Decrease quantity',
    increaseAria: 'Increase quantity',
  },
  sizeSelector: { label: 'Select Size' },
  relatedProducts: { title: 'You Might Also Love' },
  tabs: {
    description: {
      label: 'Description',
      title: 'About This Product',
      featuresTitle: 'Features',
      features: [
        { icon: 'Sparkles', text: 'Premium soft plush material' },
        { icon: 'Heart', text: 'Handcrafted with attention to detail' },
        { icon: 'RefreshCcw', text: 'Easy to clean' },
        { icon: 'Gift', text: 'Perfect gift for all ages' },
      ],
    },
    reviews: {
      label: 'Reviews',
      emptyText: 'No reviews yet. Be the first to share your love!',
    },
    shipping: {
      label: 'Shipping',
      options: [
        {
          icon: 'Truck',
          title: 'Standard Shipping',
          description: '3-5 business days',
        },
        {
          icon: 'Sparkles',
          title: 'Express Shipping',
          description: '1-2 business days',
        },
        {
          icon: 'Gift',
          title: 'Gift Wrapping',
          description: 'Available at checkout',
        },
      ],
    },
  },
  trustBadges: [
    { icon: 'Truck', text: 'Free shipping over ₹2500' },
    { icon: 'ShieldCheck', text: 'Secure checkout' },
    { icon: 'Package', text: '30-day returns' },
  ],
} as const;

export const SHOP_CONTENT = {
  title: 'Our Collection',
  subtitle: (count: number) => `${count} adorable friends waiting for you`,
  empty: {
    title: 'No friends found',
    description: 'Try adjusting your filters to find your perfect match.',
    buttonLabel: 'Clear All Filters',
    icon: 'Search',
  },
  filters: {
    title: 'Filters',
    searchPlaceholder: COMMON_CONTENT.placeholders.search,
    categories: { title: 'Categories' },
    priceRange: { title: 'Price Range' },
    size: { title: 'Size' },
    colors: { title: 'Colors' },
    clearButton: 'Clear All',
  },
  sort: {
    label: 'Sort by:',
    options: [
      { value: 'featured', label: 'Featured' },
      { value: 'newest', label: 'Newest' },
      { value: 'price-low', label: 'Price: Low to High' },
      { value: 'price-high', label: 'Price: High to Low' },
      { value: 'rating', label: 'Highest Rated' },
    ],
  },
  activeFilters: {
    label: 'Active Filters',
    sizePrefix: 'Size:',
  },
  mobile: {
    filterButton: 'Filters',
  },
} as const;
